const feather = require('feather-icons');
feather.replace();

import "./jquery-global";
import "./menu-toggle";
import "./form-submit";
import "./form-submit-steps";
